<template>
  <div class="page-table musteriTanim  mainDiv mb-30" id="affix-container">
    <div class="animated fadeInUp card-base baslikBg">Yıllık izin Tanımla</div>
    <el-row class="mt-10" :gutter="10" v-loading="loading || addLoading"
            :element-loading-text='loading ? "Yükleniyor" : addLoading ? "Yıllık İzin Tanımlanıyor. Lütfen Bekleyiniz." : ""'
            element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)">
      <el-form label-position="top" status-icon :model="izinForm" :rules="rulesIzin" class="demo-ruleForm"
               ref="izinForm">
        <el-col :lg="18" :md="18" :sm="24" :xs="24">
          <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft p-15">
            <el-row :gutter="20">
              <el-col :xl="8" :lg="8" :md="12" :sm="12">
                <el-form-item label="Personel" prop="personelID">
                  <el-select @change="getGecmisIzinData($event)" v-model="izinForm.personelID"
                             placeholder="Personel Seçiniz" size="mini"
                             style="width: 100%">
                    <el-option v-for="item in personelList" :key="item.ID" :label="item.adSoyad" :value="item.ID"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xl="6" :lg="6" :md="12" :sm="12">
                <el-form-item label="İzin Türü" prop="izinTuru">
                  <el-select v-model="izinForm.izinTuru" placeholder="İzin Türünü Seçiniz" size="mini"
                             style="width: 100%">
                    <el-option v-for="item in izinTuruOptions" :key="item.value" :label="item.label"
                               :value="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xl="10" :lg="10" :md="12" :sm="12">
                <el-form-item label="İzin Tarihi" prop="izinTarihi">
                  <el-date-picker
                      @change="dateChange($event)"
                      style="width: 100%"
                      size="mini"
                      v-model="izinForm.izinTarihi"
                      type="daterange"
                      range-separator="."
                      start-placeholder="Başlangıç Tarihi"
                      end-placeholder="Bitiş Tarihi"
                      format="dd.MM.yyyy"
                      value-format="yyyy-MM-dd"
                      :picker-options="datePickerOptions()"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :xl="11" :lg="11" :md="12" :sm="12">
                <el-form-item label="Açıklama" prop="aciklama">
                  <el-input type="textarea" v-model="izinForm.aciklama"/>
                </el-form-item>
              </el-col>
              <el-col :xl="3" :lg="3" :md="12" :sm="12">
                <el-form-item label="Belge" prop="belge">
                  <el-upload
                      action=""
                      :limit="1"
                      :auto-upload="false"
                      list-type="picture-card"
                      :file-list="izinForm.belge"
                      :on-remove="handleRemove"
                      :on-change="handleChange"
                      class="belge"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :xl="10" :lg="10" :md="12" :sm="12">
                <el-row v-if="izinForm.izinTarihi != ''" :gutter="10" class="day-info-area">
                  <el-col :span="8">
                    <div class="izin-info-box">
                      " {{ izinForm.dayInfo.izinGunu }} " İzin Günü
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="izin-info-box">
                      " {{ izinForm.dayInfo.haftalikIzin }} " Haftalık İzin
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="izin-info-box">
                      " {{ izinForm.dayInfo.resmiTatil }} " Resmi Tatil
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :lg="6" :md="6" :sm="24" :xs="24">
          <el-collapse class="yanForm animated fadeInUp" v-model="activeCollapse">
            <el-collapse-item class="card-shadow--medium" name="8"
                              :title='$t("src.views.apps.genel.durum")'>
              <el-row>
                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                  <el-form-item prop="durum">
                    <el-select size="small" v-model="izinForm.durum"
                               :placeholder='$t("src.views.apps.messages.addBultenTitle")' style="width: 100%">
                      <el-option value="1" label='Aktif'></el-option>
                      <el-option value="0" label='Pasif'></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-button size="mini" v-on:click="izinTanimla('izinForm', izinForm.durum)" class="onayBtn"
                           type="primary">
                  <label>Kaydet</label>
                </el-button>
                <el-popover placement="bottom" width="300" v-model="visibleSil">
                  <p>{{ $t('src.views.apps.messages.clearFormAlert') }}</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="primary" @click="resetForm('izinForm')">
                      {{ $t('src.views.apps.genel.yes') }}
                    </el-button>
                    <el-button size="mini" @click="visibleSil = false;">
                      {{ $t('src.views.apps.genel.no') }}
                    </el-button>
                  </div>
                  <el-button size="mini" slot="reference">
                    {{ $t('src.views.apps.genel.temizle') }}
                  </el-button>
                </el-popover>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </el-col>
        <el-col v-if="false && izinForm.personelID != ''" :lg="18" :md="18" :sm="24" :xs="24">
          <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft p-15 mt-10">
            <el-row :gutter="20">
              <el-col :span="24">
                <h4 class="m-0">Turan Ali Adlı Personelin Geçmiş İzin Listesi ( {{ gecmisData.length }} )</h4>
                <el-divider/>
                <el-table border stripe :data="gecmisData" style="width: 100%">
                  <el-table-column prop="personel" label="Personel"/>
                  <el-table-column prop="izinTuru" label="İzin Türü"/>
                  <el-table-column prop="baslangicTarihi" label="Başlangıç Tarihi"/>
                  <el-table-column prop="bitisTarihi" label="Bitiş Tarihi"/>
                  <el-table-column prop="aciklama" label="Açıklama"/>
                  <el-table-column prop="belge" label='Belge' width="100">
                    <template slot-scope="props">
                      <div class="text-center">
                        <el-image @click="downloadFile(props.row.belge)"
                                  :src="izinService.belge + props.row.belge"
                                  style="width: 50px; height: 50px;cursor: pointer"/>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-form>
    </el-row>
  </div>
</template>
<script>

import yoneticiService from "@/WSProvider/YoneticiService";
import notification from "@/notification";
import izinService from "@/WSProvider/izinService";
import $ from 'jquery'
import moment from 'moment'
import tatilService from "@/WSProvider/TatilService";
import EventBus from "@/components/event-bus";
import _ from "lodash";

export default {
  name: "IzinTanimla",
  components: {},
  created() {
    this.getTatilListesi()
    this.getPersonelList()
  },
  data() {
    return {
      loading: false,
      addLoading: false,
      visibleSil: false,
      izinTuruOptions: [
        {label: 'Yıllık İzin', value: '1'},
        {label: 'Rapor', value: '2'},
        {label: 'Mazeret İzni', value: '3'},
        {label: 'Ücretsiz İzin', value: '4'},
        {label: 'Alacak İzin', value: '5'},
        {label: 'İş Arama İzni', value: '6'},
        {label: 'Pandemi İzni', value: '7'},
      ],
      activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
      gecmisData: [
        {
          id: 1,
          personel: 'Turan ALi',
          baslangicTarihi: '2023-25-12',
          bitisTarihi: '2024-25-12',
          izinTuru: '2',
          aciklama: 'Doğum İzni',
          belge: '',
        }
      ],
      disabledTarihler: [],
      tatilList: [],
      personelList: [],
      izinForm: {
        personelID: '',
        belge: [],
        izinTarihi: '',
        izinTuru: '1',
        aciklama: '',
        durum: '1',
        dayInfo: {
          izinGunu: 0,
          haftalikIzin: 0,
          resmiTatil: 0,
        },
      },
      rulesIzin: {
        personelID: [{
          required: true,
          message: "Lütfen Personel Seçiniz.",
          trigger: 'blur'
        }],
        belge: [{
          required: false,
          message: "Lütfen Belge Ekleyiniz.",
          trigger: 'blur'
        }],
        izinTarihi: [{
          required: true,
          message: "Lütfen Tarih Seçiniz.",
          trigger: 'blur'
        }],
        izinTuru: [{
          required: true,
          message: "Lütfen İzin Türünü Seçiniz.",
          trigger: 'blur'
        }],
        aciklama: [{
          required: false,
          message: "Lütfen Açıklama Giriniz.",
          trigger: 'blur'
        }],
        durum: [{
          required: false,
          message: "Lütfen Durum Seçiniz.",
          trigger: 'blur'
        }],
      },
    }
  },
  computed: {
    izinService() {
      return izinService
    },
    izinID() {
      return this.$store.getters.getIzinID
    },
  },
  methods: {
    dateChange(event) {
      const baslangic = event[0]
      const bitis = event[1]
      var start = moment(baslangic),
          end = moment(bitis),
          day = 0; // Pazar
      var result = [];
      var current = start.clone();
      while (current.day(7 + day).isBefore(end)) result.push(current.clone())

      const data = result.map(m => m.format('YYYY-MM-DD'))
      const toplamGun = moment(bitis).diff(moment(baslangic), 'days')
      var izinliGunler = function (startDate, endDate) {
        var now = startDate.clone(), dates = [];
        while (now.isSameOrBefore(endDate)) {
          dates.push(now.format('YYYY-MM-DD'));
          now.add(1, 'days');
        }
        return dates;
      };
      izinliGunler(moment(baslangic), moment(bitis))
      var araTarih = function (startDate, endDate) {
        var now = startDate.clone(), dates = [];
        while (now.isSameOrBefore(endDate)) {
          dates.push(now.format('YYYY-MM-DD'));
          now.add(1, 'days');
        }
        return dates;
      };
      // ? Resmi Tatil Sayisi
      const tarihler = araTarih(moment(baslangic), moment(bitis))
      let count = 0
      if (this.disabledTarihler.length > 0 && tarihler.length > 0) {
        tarihler.forEach(item => {
          const isTrue = _.includes(this.disabledTarihler, item)
          if (isTrue) count++
        })
      }
      this.izinForm.dayInfo.resmiTatil = count
      this.izinForm.dayInfo.izinGunu = toplamGun - data.length - count
      this.izinForm.dayInfo.haftalikIzin = data.length
    },
    datePickerOptions() {
      const self = this
      return {
        firstDayOfWeek: 1,
        disabledDate: date => {
          const disabledTarihler = self.disabledTarihler.find(item => moment(item).format("MMM Do YY") == moment(date).format("MMM Do YY"))
          return disabledTarihler
        }
      };
    },
    getGecmisIzinData(personelID) {
      return false
      const self = this
      this.loading = true;
      izinService.gecmisIzinListesi(personelID).then((response) => {
        if (response.status == 200) {
          localStorage.setItem("userDataDemirag", response.token)
          this.gecmisData = response.data
        }
      }).catch(err => {
        if (err.responseJSON) {
          let error = err.responseJSON
          if (error.status == 401) {
            notification.Status(150, this);
          } else if (error.status == 404) {
            this.gecmisData = [];
          } else notification.Status("errorMsg", this, error.errMsg || error.msg)
        }
      }).finally(() => self.loading = false)
    },
    downloadFile(belge) {
      var downloadLink = document.createElement("a");
      downloadLink.href = izinService.belge + belge;
      downloadLink.download = belge;
      downloadLink.target = "_blank";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    handleChange(file) {
      file.raw['tmp_name'] = file.url
      this.izinForm.belge.push(file)
      $('.belge .el-upload--picture-card').hide();
    },
    handleRemove() {
      $('.belge .el-upload--picture-card').show();
      this.izinForm.belge = []
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.visibleSil = false;
      this.izinForm.baslangicTarihi = ''
      this.izinForm.bitisTarihi = ''
      this.izinForm.izinTuru = '1'
      this.izinForm.personelID = ''
      this.izinForm.belge = []
      this.izinForm.aciklama = ''
      this.izinForm.durum = '1'
    },
    getPersonelList() {
      const self = this
      this.loading = true;
      yoneticiService.personelListesi().then((response) => {
        if (response.status == 200) {
          localStorage.setItem("userDataDemirag", response.token)
          this.personelList = response.data
        }
      }).catch(err => {
        if (err.responseJSON) {
          let error = err.responseJSON
          if (error.status == 401) {
            notification.Status(150, this);
          } else if (error.status == 404) {
            this.personelList = [];
          } else notification.Status("errorMsg", this, error.errMsg || error.msg)
        }
      }).finally(() => self.loading = false)
    },
    izinTanimla(formName) {
      const self = this
      this.$refs[formName].validate((valid, errors) => {
        if (valid) {
          this.addLoading = true;
          izinService.izinTanimla(this.izinForm).then((response) => {
            if (response.status == 200) {
              localStorage.setItem("userDataDemirag", response.token)
              notification.Status("success", this, response.msg)
              EventBus.$emit("izinListesi");
              this.$refs[formName].resetFields();
              $('.belge .el-upload--picture-card').show();
            } else notification.Status("errorMsg", this, response.msg || response.errMsg)
          }).catch(err => {
            if (err.responseJSON) {
              let error = err.responseJSON
              if (error.status == 401) {
                notification.Status(150, this);
              } else notification.Status("errorMsg", this, error.errMsg || error.msg)
            }
          }).finally(() => self.addLoading = false)
        }
      })
    },
    getTatilListesi() {
      tatilService.resmiTatilListele(0, 10000000, new Date().getFullYear()).then((response) => {
        response.data.forEach(function (e) {
          e.baslamaTarihi = moment(e.baslamaTarihi).format('YYYY-MM-DD');
          e.bitisTarihi = moment(e.bitisTarihi).format('YYYY-MM-DD');
        })
        if (response.status == 200) {
          this.tatilList = response.data;
          this.$store.commit('setTatilList', response.data)
          this.disabledDatesFilter()
        } else this.tatilList = []
      }).catch(err => {
        if (err.responseJSON) {
          let error = err.responseJSON
          if (error.status == 401) {
            notification.Status(150, this);
          } else if (error.status == 404) {
            this.tatilList = [];
          } else notification.Status("errorMsg", this, error.errMsg)
        }
      })
    },
    disabledDatesFilter() {
      var araTarih = function (startDate, endDate) {
        var now = startDate.clone(), dates = [];
        while (now.isSameOrBefore(endDate)) {
          dates.push(now.format('YYYY-MM-DD'));
          now.add(1, 'days');
        }
        return dates;
      };
      this.tatilList.forEach(item => araTarih(moment(item.baslamaTarihi), moment(item.bitisTarihi)).forEach(veri => this.disabledTarihler.push(veri)))
    },
  }
}

</script>
<style scoped>
.day-info-area {
  .izin-info-box {
    color: white;
    transition: 200ms;
    border-radius: 6px;
    height: 40px;
    width: 100%;
    display: inline-flex;
    place-items: center;
    place-content: center;
    box-shadow: rgba(0, 0, 0, 0.15) 0 15px 25px, rgba(0, 0, 0, 0.05) 0 5px 10px;
  }

  .el-col {
    &:nth-child(1) .izin-info-box {
      background-color: #3B9AE1;

      &:hover {
        transition: 200ms;
        background-color: #0f6fb4;
      }
    }

    &:nth-child(2) .izin-info-box {
      background-color: #FF9843;

      &:hover {
        transition: 200ms;
        background-color: #cb6f23;
      }
    }

    &:nth-child(3) .izin-info-box {
      background-color: #03C988;

      &:hover {
        transition: 200ms;
        background-color: #0f835d;
      }
    }
  }
}
</style>